import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useXRefState } from '@myst-theme/providers';
import { createElement as e } from 'react';
import classNames from 'classnames';
import { MyST } from './MyST.js';
export function HashLink({ id, kind, title = `Link to this ${kind}`, children = '¶', hover, className = 'font-normal', hideInPopup, }) {
    const { inCrossRef } = useXRefState();
    if (inCrossRef || !id) {
        // If we are in a cross-reference pop-out, either hide hash link
        // or return something that is **not** a link
        return hideInPopup ? null : (_jsx("span", { className: classNames('select-none', className), children: children }));
    }
    const scroll = (evt) => {
        evt.preventDefault();
        const el = document.getElementById(id);
        el === null || el === void 0 ? void 0 : el.scrollIntoView({ behavior: 'smooth' });
        history.replaceState(undefined, '', `#${id}`);
    };
    return (_jsx("a", { className: classNames('select-none no-underline text-inherit hover:text-inherit', className, {
            'transition-opacity opacity-0 focus:opacity-100 group-hover:opacity-70': hover,
            'hover:underline': !hover,
        }), onClick: scroll, href: `#${id}`, title: title, "aria-label": title, children: children }));
}
const Heading = ({ node }) => {
    const { enumerator, depth, key, identifier, html_id } = node;
    const id = html_id || identifier || key;
    const textContent = (_jsxs(_Fragment, { children: [enumerator && _jsx("span", { className: "mr-3 select-none", children: enumerator }), _jsx("span", { className: "heading-text", children: _jsx(MyST, { ast: node.children }) }), _jsx(HashLink, { id: id, kind: "Section", className: "px-2 font-normal", hover: true, hideInPopup: true })] }));
    // The `heading-text` class is picked up in the Outline to select without the enumerator and "#" link
    return e(`h${depth}`, {
        id,
        className: 'relative group',
    }, textContent);
};
const HEADING_RENDERERS = {
    heading: Heading,
};
export default HEADING_RENDERERS;
